import { render, staticRenderFns } from "./product-attributes.vue?vue&type=template&id=8b872518&scoped=true"
import script from "./product-attributes.vue?vue&type=script&lang=js"
export * from "./product-attributes.vue?vue&type=script&lang=js"
import style0 from "./product-attributes.vue?vue&type=style&index=0&id=8b872518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b872518",
  null
  
)

export default component.exports